import React from 'react';
import '../assets/css/spinner_dot.css';

class LoadingSpinner_dot extends React.Component {
  render() {
    return (
      <div className="spcontainer">
        <div className="loader">
          <div className="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    );
  }
}
export default LoadingSpinner_dot; // expose the HelloWorld component to other modules
